import React from 'react';
import styles from './statusColor.module.scss';

const Status = ({ status, table = false, center, sms }) => {
  if (!status) {
    return null;
  }
  return (
    <>
      {typeof status === 'object' && status?.length === 1 && (
        <div
          className={`${table ? styles.block : styles.status} ${center ? styles.center : ''}`}
          style={{ backgroundColor: `${status[0]?.color}` }}
        >
          {status[0]?.name}
        </div>
      )}
      {typeof status === 'object' && status?.length === 2 && (
        <div
          className={`${table ? styles.block : styles.status} ${center ? styles.center : ''}`}
          style={{ background: `linear-gradient(to bottom left, ${status[1]?.color} 52%,${status[0]?.color} 48%)` }}
        >
          {status[0]?.name}
        </div>
      )}
      {typeof status === 'string' && (
        <div
          className={`${table ? styles.block : styles.status} ${center ? styles.center : ''}`}
          style={{ marginLeft: center ? 25 : '', width: sms ? 115 : '' }}
        >
          {status}
        </div>
      )}
    </>
  );
};

export default Status;
